import moment from "moment";
import { connect } from "react-redux";

import {
  rescheduleEventExplicit,
  setActiveCrew,
  scheduleBid,
  scheduleJobExplicit,
  schedulePurchaseOrderExplicit,
  scheduleAppointmentExplicit,
} from "../../redux/calendar";
import { toggleCrewModal, toggleLoadReportModal } from "../../redux/modals";
import { open as togglePrintWorkOrderModal } from "../../redux/modals/printWorkOrderModal";
import makeEventsByCrew from "../../selectors/eventsByCrew";
import DayView from "./DayView";
import {
  updateSettings,
  showEstimatedQuantitiesSelector,
} from "../../redux/settings";
const eventsByCrew = makeEventsByCrew(true);

const mapStateToProps = (state) => ({
  date: moment(state.calendar.date),
  hasCalendarEventUpdate:
    state.tokenInfo.scope.indexOf("calendarEvents:update") > -1,
  entity: state.settings.entity,
  events: state.events.events,
  eventsByCrew: eventsByCrew(state),
  jobTypes: state.dropdowns.jobTypes,
  settings: state.settings,
  showTotalsRow: state.settings.totalsRowFields.fields.showTotalsRow.visible,
  showUOMTotals:
    state.settings.totalsRowFields.fields.statistics.uomTotals.visible,
  showJobCounts:
    state.settings.totalsRowFields.fields.statistics.jobCounts.visible,
  includedItemTypes: state.settings.totalsRowFields.fields.includedItemTypes,
  showEstimatedQuantities: showEstimatedQuantitiesSelector(state),
});

const mapDispatchToProps = {
  onCrewSelect: setActiveCrew,
  onEditCrewClick: toggleCrewModal,
  onLoadReportClick: toggleLoadReportModal,
  onReschedule: rescheduleEventExplicit,
  onPrintWorkOrder: togglePrintWorkOrderModal,
  onScheduleBid: scheduleBid,
  onScheduleDelivery: schedulePurchaseOrderExplicit,
  onScheduleJob: scheduleJobExplicit,
  onSheeduleAppointment: scheduleAppointmentExplicit,
  updateSettings: updateSettings,
};

const mergeProps = (
  { hasCalendarEventUpdate, ...stateProps },
  { onEditCrewClick, ...dispatchProps },
  ownProps
) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onEditCrewClick: hasCalendarEventUpdate ? onEditCrewClick : null,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(DayView);
